export const formatPrice = (n, str = '.') => {
    var a = n?.toString().replaceAll(".", "").replaceAll(',', '');
    return a?.replace(/./g, function (c, i, a) {
        return i > 0 && c !== str && (a.length - i) % 3 === 0 ? str + c : c;
    });
}